export const isUserGroupIdValid = (value: string): boolean =>
  !!value.trim() &&
  !/[a-zA-Z]/.test(value) &&
  Number.isInteger(Number(value)) &&
  Number(value) >= 0;

export const toInteger = (value: string): number | undefined =>
  Number.isNaN(Number.parseInt(value)) ? undefined : Number.parseInt(value);
